import React from 'react';

import { Loader } from '@opendoor/bricks-next';

import { AsyncFeatureFlagGate, type DefaultAsyncFeatureFlagProps } from '../flags/FeatureFlagGate';
import { AccountForm as AccountFormCinderblocks } from './AccountFormCinderblocks';
import type { IAccountFormProps } from './AccountFormCinderblocks/AccountForm';
import { AccountFormV2 } from './AccountFormV2/AccountFormV2';

type AccountFormContainerProps = {
  accountFormProps: IAccountFormProps;
  featureFlagProps: DefaultAsyncFeatureFlagProps;
};

export const AccountForm: React.FC<AccountFormContainerProps> = ({
  accountFormProps,
  featureFlagProps,
}) => {
  const {
    flag = 'auth-fe-account-form',
    loading = <Loader size="small" />,
    ...flagProps
  } = featureFlagProps;
  return (
    <AsyncFeatureFlagGate
      flag={flag}
      disabled={<AccountFormCinderblocks {...accountFormProps} />}
      enabled={<AccountFormV2 {...accountFormProps} />}
      loading={loading}
      {...flagProps}
    />
  );
};
